import React from "react";
import "../SCSS/styles.css";
import { getLink } from "../../Common/functions";

function Section1() {
  return (
    <section className="section-1-container">
      <p className="section-description-container">
        <h2>
          Why choose Updapt ESG Data management, Reporting & Analytics Software
          for your Business?
        </h2>
      </p>
      <p className="section-description-container">
        <div className="section-heading">
          Solution for Enhancing and Streamlining ESG reporting.
        </div>
        <p className="section-description">
          Updapt {getLink("ESG Software", "/")} Software offers a complete and
          comprehensive report generation and pre-built reporting template.
          These automated mapping capabilities are aligned with global
          sustainability and ESG standards & frameworks like TCFD, CSRD, ESRS,
          IFRS and others. We offer an end-to-end digital sustainability
          reporting solution for all medium and large sized industries.{" "}
        </p>
      </p>
      <p className="section-description-container">
        <div className="section-heading">Effectively Manage the ESG data</div>
        <p className="section-description">
          The platform is designed for speed and scalability. ESG workflows that
          typically take weeks can be completed up to 18 times faster using
          Updapt’s smart automation and analytics features. It supports seamless
          integration through APIs, FTP, database connectors, and OCR tools,
          allowing businesses to pull data from multiple systems quickly. The
          dashboard and reporting tools are intuitive and customizable, helping
          users identify ESG performance gaps, track KPIs, and respond
          proactively with data-driven decisions.
        </p>
      </p>
      <p className="section-description-container">
        <div className="section-heading">Supplier Assessment Made Easy</div>
        <p className="section-description">
          Assess ESG performance across your value chain with dynamic
          scorecards, custom questionnaires, and risk ratings. Track supplier
          actions, compare performance, and drive sustainability deeper into
          your operations with clear insights and built-in accountability tools.
        </p>
      </p>
      <p className="section-description-container">
        <div className="section-heading">Reduces ESG Reporting Costs</div>
        <p className="section-description">
          Updapt helps businesses across industries reduce the time and expense
          of {getLink("ESG reporting", "/solutions/esg-reporting")} by
          automating{" "}
          {getLink("data collection", "/solutions/esg-data-management")},
          streamlining disclosures, and replacing manual workflows. The platform
          delivers results up to 18x faster with an agile, scalable architecture
          that fits seamlessly into existing systems, making ESG reporting
          simpler, faster, and far more cost-effective.
        </p>
      </p>
    </section>
  );
}

export default Section1;
